import React from "react";
import { Link } from "react-router-dom";

interface MastersBreadcrumbProps {
  /** Current master page label, e.g. "Vaccines" */
  current: string;
}

/**
 * Shared breadcrumb for all Masters sub-lists.
 * Masters → current page. Keeps navigation consistent across the app.
 */
const MastersBreadcrumb: React.FC<MastersBreadcrumbProps> = ({ current }) => {
  return (
    <nav className="mb-3" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm">
        <li>
          <Link
            to="/masters"
            className="inline-flex items-center gap-1 font-medium text-indigo-600 hover:text-indigo-800"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="w-4 h-4"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z"
                clipRule="evenodd"
              />
            </svg>
            Masters
          </Link>
        </li>
        <li className="text-gray-400" aria-hidden="true">
          /
        </li>
        <li className="font-medium text-gray-700" aria-current="page">
          {current}
        </li>
      </ol>
    </nav>
  );
};

export default MastersBreadcrumb;
